<template>
  <div>
    <!-- Title -->
    <v-container>
      <v-card class="mx-auto">
        <template v-if="this.partGroup != null">
          <v-card-title>
            Part Group Details
          </v-card-title>

          <v-form>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field label="Name" v-model="partGroup.name" />
                  <v-text-field label="Words to include" v-model="partGroup.wordsToInclude" />
                  <v-text-field label="Words to exclude" v-model="partGroup.wordsToExclude" />
                  <v-text-field label="Default Refined Min Qty" v-model="partGroup.defaultRefinedMinQty" />
                  <v-text-field label="Default Qty Cap" v-model="partGroup.defaultQtyCap" />
                  <v-text-field label="Default min qty to scan" v-model="partGroup.defaultMinQtyToScan" />
                  <v-text-field label="eBay categoryIDs (up to 3, comma-delimited), leave blank for default"
                    v-model="partGroup.categoryIDs" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <v-row>
            <v-col cols="5">
              <v-btn color="primary" class="ma-3" v-on:click="savePartGroup">
                <v-icon left>mdi-content-save</v-icon>
                Save
              </v-btn>
              <v-btn color="warning" class="ma-3" v-on:click="navigateBackToPartGroups">
                <v-icon left>mdi-arrow-left</v-icon>
                Back
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn color="error" class="ma-3" v-on:click="deletePartGroup">
                <v-icon left>mdi-delete</v-icon>
                Delete
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <p class="display-1 text--primary">
            Loading...
          </p>
        </template>
      </v-card>
    </v-container>
    <!-- /Title -->

  </div>
</template>

<script>
// API wrapper
import { PartGroupsService } from '../services/api/partGroups';
const apiPartGroups = new PartGroupsService();

export default {
  data() {
    return {
      partGroup: null,
      loadingPartGroup: true,
    }
  },

  mounted() {
    this.getPartGroup();
  },

  methods: {

    getPartGroup() {
      this.loadingPartGroup = true;

      if (this.$route.params.name) {
        apiPartGroups.getPartGroupByName(this.$route.params.name).then((data) => {
          this.partGroup = data
        });
      } else if (this.$route.params.id) {
        apiPartGroups.getPartGroup(this.$route.params.id).then((data) => {
          this.partGroup = data
        });
      } else {
        this.$router.replace({ name: "PartGroups" }); // redirect to PartGroups page
      }

      this.loadingPartGroup = false;
    },

    async savePartGroup() {

      // Save the PartGroup to the database.
      await apiPartGroups.savePartGroup(this.partGroup).then((data) => {
        this.partGroup = data
      });

      // Display success message
      this.$notify({
        title: 'Part Group Updated!',
        // text: 'Hello user!',
        type: 'success'
      });

      // Send the user to the detail page for that part.
      //this.$router.push({ name: "Part", params: { id : this.part.id } });
    },

    async deletePartGroup() {
      // confirm deletion
      if (!confirm("Are you sure you want to delete this Part Group?")) {
        return;
      }

      // Delete the PartGroup from the database.
      await apiPartGroups.deletePartGroup(this.partGroup.id).then((data) => {
        this.partGroup = data
      });
      await this.navigateBackToPartGroups();
    },

    async navigateBackToPartGroups() {
      await this.$router.replace({ name: "PartGroups" }); // go back to the PartGroups page
    }
  }
}
</script>